var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Button from '@storeblocks/button';
import { HeadingBase } from './styled';
function Heading(_a) {
    var { labelId, onClose, children } = _a, props = __rest(_a, ["labelId", "onClose", "children"]);
    return (React.createElement(HeadingBase, Object.assign({}, props),
        React.createElement("h3", { id: labelId }, children),
        React.createElement(Button, { "aria-label": "close|lukk", variant: "icon", iconLeft: "close", onClick: onClose })));
}
export default Heading;
